<template>
  <div>

    <div :key="'type'" class="delivery_oplata substrate" style="margin-top: 0">
      <div class="do_title">
        {{ text('website_ask_city') }}
      </div>
      <div class="delivery_oplata_list">

        <label class="dol_block" v-for="item in $store.getters.guardCities">
          <input :value="item.id" name="type" type="radio" v-model="city"/>
          <div class="dol_content">
            <div class="dol_inner">
              <div class="dol_name">
                <template>{{ item.name }}</template>
              </div>
            </div>
          </div>
        </label>

      </div>
    </div>

  </div>
</template>

<script>
  import {
    SET_GUARD_CITY_ID
  } from '@/store/mutations.type'
  import {GUARD_GET_CITIES, GUARD_NEXT} from '@/store/actions.type'

  export default {
    name: 'City',

    data() {
      return {
        city: null
      }
    },

    watch: {
      city(city) {
        this.$emit('update:cityData', city)
      }
    },

    methods: {
      async next() {
        await this.$store.commit(SET_GUARD_CITY_ID, this.city)
        await this.$store.dispatch(GUARD_NEXT)
      }
    },

    async mounted() {
      this.city = this.$store.getters.guardCityID
      if (this.$store.getters.guardCities.length === 1) {
        await this.next()
      }
    },

    updated() {
      this.$emit('update:cityData', this.city)
    }

  }
</script>
